<template>
  <div>
    <div>
      <LoaderTuin :is-loading="loader" />
    </div>
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
    />
    <!-- Dropzone para múltiples archivos -->
    <div
      :class="[
        'border-4 border-dashed p-6 rounded-md cursor-pointer',
        dragging ? 'border-blue-500 bg-blue-100' : 'border-gray-300 bg-gray-50',
      ]"
      class="flex flex-col items-center justify-center space-y-4 p-4 m-4"
      @dragover.prevent
      @dragenter.prevent="dragging = true"
      @dragleave="dragging = false"
      @drop.prevent="handleDrop"
      @click="triggerFileInput"
    >
      <p class="text-gray-500 text-center">
        Arrastra y suelta archivos aquí o haz clic para seleccionarlos
      </p>
      <input
        ref="fileInput"
        type="file"
        class="hidden"
        accept="image/*"
        multiple
        @change="handleFileSelect"
      >
    </div>

    <!-- Lista de previews de archivos cargados -->
    <div
      v-if="files.length > 0"
      class="mt-4"
    >
      <h3 class="text-lg font-semibold">
        Archivos cargados:
      </h3>
      <p>
        Estos son los archivos que has cargado desde tu dispositivo. Si todo
        está correcto, haz clic en el botón 'Guardar imágenes'. Una vez
        guardadas, podrás verlas en la ficha técnica.
      </p>
      <p>
        <strong>
          Recuerda colocar la mejor vista de tu inmueble en la posición número
          uno, ya que será la foto principal al compartir en Facebook y
          WhatsApp. Si ya tienes imágenes guardadas, asegúrate de no duplicar el
          orden con las existentes
        </strong>
      </p>

      <div class="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4">
        <div
          v-for="(file, index) in files"
          :key="index"
          class="max-w-sm mx-auto bg-white shadow-md rounded-md overflow-hidden relative"
        >
          <!-- Indicador de compresión y tamaño 
          <div 
            v-if="file.isCompressing"
            class="absolute top-2 left-2 bg-blue-500 text-white text-xs px-2 py-1 rounded z-10"
          >
            Optimizando...
          </div>
          <div 
            v-else-if="file.wasCompressed"
            class="absolute top-2 left-2 bg-green-500 text-white text-xs px-2 py-1 rounded z-10"
          >
            Optimizada
          </div>-->
          <!-- Indicador de tamaño 
          <div 
            v-if="file.compressedSize && file.compressedSize > 800 * 1024"
            class="absolute top-2 right-2 bg-orange-500 text-white text-xs px-2 py-1 rounded z-10"
          >
            Grande
          </div>
          <div 
            v-else-if="file.compressedSize && file.compressedSize <= 500 * 1024"
            class="absolute top-2 right-2 bg-green-600 text-white text-xs px-2 py-1 rounded z-10"
          >
            Óptima
          </div>-->
          
          <img
            :src="file.base64"
            alt="Imagen"
            class="w-full h-48 object-cover"
          >
          <div class="p-4 text-center">
            <p class="text-gray-700 text-sm mb-2">
              {{ file.name }}
            </p>
             <!--<p class="text-xs text-gray-500 mb-4">
              {{ formatFileSize(file.originalSize) }}
              <span v-if="file.wasCompressed">
                → {{ formatFileSize(file.compressedSize) }}
              </span>
            </p>-->
            <div class="flex justify-center items-center space-x-4">
              <fwb-input
                v-model="file.order"
                label="Orden"
                type="number"
                min="1"
                class="w-20"
              />
              <!-- BOTÓN ARREGLADO: Ahora sí elimina archivos no guardados -->
              <button
                @click="removeFile(index)"
                class="text-gray-500 hover:text-red-500 items-center justify-items-center"
              >
                <svg
                  class="mt-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="#df0707"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="m18 9l-.84 8.398c-.127 1.273-.19 1.909-.48 2.39a2.5 2.5 0 0 1-1.075.973C15.098 21 14.46 21 13.18 21h-2.36c-1.279 0-1.918 0-2.425-.24a2.5 2.5 0 0 1-1.076-.973c-.288-.48-.352-1.116-.48-2.389L6 9m7.5 6.5v-5m-3 5v-5m-6-4h4.615m0 0l.386-2.672c.112-.486.516-.828.98-.828h3.038c.464 0 .867.342.98.828l.386 2.672m-5.77 0h5.77m0 0H19.5"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        class="bg-blue-500 text-white px-4 py-2 rounded mt-4"
        :disabled="files.some(f => f.isCompressing)"
        @click="saveFiles"
      >
        <span v-if="files.some(f => f.isCompressing)">
          Procesando imágenes...
        </span>
        <span v-else>
          Guardar imágenes
        </span>
      </button>
    </div>

    <!-- Lista de imagenes guardadas -->
    <div
      v-if="gallery.length > 0"
      class="mt-10"
    >
      <h3 class="text-lg font-semibold">
        Fotos de la propiedad
      </h3>
      <p>
        Aquí puedes ver las fotos que se muestran en la ficha de tu propiedad.
        Debajo de cada imagen está el campo 'Orden', que define su posición.
      </p>
      <p>
        <strong>
          Coloca la mejor vista de tu inmueble en la posición número uno, ya que
          será la foto principal al compartir en Facebook y WhatsApp.
        </strong>
      </p>

      <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
        <div
          v-for="(img, index) in gallery"
          :key="index"
          class="max-w-sm mx-auto bg-white shadow-md rounded-md overflow-hidden"
        >
          <img
            :src="img.path_img"
            alt="Imagen"
            class="w-full h-48 object-cover"
          >
          <div class="p-4 text-center">
            <div class="flex justify-center items-center space-x-4">
              <fwb-input
                v-model="img.order"
                label="Orden"
                type="number"
                min="1"
                class="w-20"
                @change="updateOrder(index)"
              />
              <button
                @click="deleteImage(img.id)"
                class="text-gray-500 hover:text-red-500"
              >
                <svg
                  class="mt-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="#df0707"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="m18 9l-.84 8.398c-.127 1.273-.19 1.909-.48 2.39a2.5 2.5 0 0 1-1.075.973C15.098 21 14.46 21 13.18 21h-2.36c-1.279 0-1.918 0-2.425-.24a2.5 2.5 0 0 1-1.076-.973c-.288-.48-.352-1.116-.48-2.389L6 9m7.5 6.5v-5m-3 5v-5m-6-4h4.615m0 0l.386-2.672c.112-.486.516-.828.98-.828h3.038c.464 0 .867.342.98.828l.386 2.672m-5.77 0h5.77m0 0H19.5"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { ref, onMounted, computed, defineProps } from "vue";
import { FwbInput } from "flowbite-vue";
import axios from "axios";

import LoaderTuin from "@/commond/LoaderTuin.vue";
import ToastAlert from "@/commond/ToastAlert.vue";
import { useStore } from "vuex";
const store = useStore();
let session = computed(() => store.getters.getUserSession);

const fileInput = ref(null);
const dragging = ref(false);
const files = ref([]);
const gallery = ref([]);

let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");
let loader = ref(false);

const props = defineProps({
  resp: {
    type: Object,
    required: true,
    default: () => ({ property_name: "" }),
  },
  propertyId: {
    type: Number,
    required: true,
    default: 0,
  },
});

// CONFIGURACIÓN AGRESIVA PARA LÍMITES DE SERVIDOR ESTRICTOS
const COMPRESSION_CONFIG = {
  // Comprimir TODO por encima de 1MB para asegurar que cada imagen sea < 1MB
  maxFileSize: 1 * 1024 * 1024, // 1MB antes de comprimir
  
  // Configuraciones de compresión MUY agresivas
  compressionLevels: [
    {
      threshold: 10 * 1024 * 1024, // 10MB+ → Compresión extrema
      maxWidth: 1200,
      maxHeight: 900,
      quality: 0.5
    },
    {
      threshold: 5 * 1024 * 1024, // 5-10MB → Compresión fuerte
      maxWidth: 1400,
      maxHeight: 1050,
      quality: 0.6
    },
    {
      threshold: 3 * 1024 * 1024, // 3-5MB → Compresión moderada
      maxWidth: 1600,
      maxHeight: 1200,
      quality: 0.65
    },
    {
      threshold: 1 * 1024 * 1024, // 1-3MB → Compresión ligera
      maxWidth: 1920,
      maxHeight: 1440,
      quality: 0.75
    }
  ],
  
  // Configuración por defecto (para archivos ya pequeños)
  defaultMaxWidth: 2048,
  defaultMaxHeight: 1536,
  defaultQuality: 0.8,
  
  // META: Cada imagen final debe pesar menos de 800KB
  targetMaxSize: 800 * 1024 // 800KB por imagen
};

const handleDrop = (event) => {
  dragging.value = false;
  const droppedFiles = event.dataTransfer.files;
  handleFiles(droppedFiles);
};

const handleFileSelect = (event) => {
  const selectedFiles = event.target.files;
  handleFiles(selectedFiles);
};

const handleFiles = (fileList) => {
  //const maxFiles = 10;
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  
  //if (fileList.length > maxFiles) {
  //  showToast("warning", `Solo puedes subir máximo ${maxFiles} archivos a la vez`);
  //  return;
  //}
  
  for (let i = 0; i < fileList.length; i++) {
    const file = fileList[i];
    
    if (!validTypes.includes(file.type)) {
      showToast("danger", `${file.name} no es un tipo de imagen válido`);
      continue;
    }
    
    // Límite más alto para permitir imágenes de Android
    const maxFileSize = 50 * 1024 * 1024; // 50MB máximo absoluto
    if (file.size > maxFileSize) {
      showToast("danger", `${file.name} es demasiado grande (máximo 50MB)`);
      continue;
    }
    
    convertToBase64(file);
  }
};

const triggerFileInput = () => {
  fileInput.value.click();
};

// FUNCIÓN MEJORADA PARA CONVERSIÓN Y COMPRESIÓN AGRESIVA
const convertToBase64 = async (file) => {
  try {
    // Crear objeto file con metadatos
    const fileObj = {
      name: file.name,
      originalSize: file.size,
      compressedSize: file.size,
      order: files.value.length + 1,
      isCompressing: true, // Siempre comprimir inicialmente
      wasCompressed: false,
      base64: null
    };
    
    // Agregar inmediatamente para mostrar el preview
    files.value.push(fileObj);
    const fileIndex = files.value.length - 1;
    
    // COMPRIMIR TODAS las imágenes por encima de 1MB
    const needsCompression = file.size > COMPRESSION_CONFIG.maxFileSize;
    
    if (needsCompression) {
      // Mostrar mensaje informativo
      //showToast("success", `Optimizando ${file.name} para subida...`);
      
      // Comprimir la imagen
      let compressedBase64 = await compressImageAdvanced(file);
      
      // Verificar si el resultado sigue siendo muy grande
      let compressedSize = Math.round((compressedBase64.length * 3) / 4);
      
      // Si aún es muy grande, comprimir más agresivamente
      if (compressedSize > COMPRESSION_CONFIG.targetMaxSize) {
        console.log(`Primera compresión insuficiente (${formatFileSize(compressedSize)}), aplicando compresión extra...`);
        compressedBase64 = await compressImageExtra(file, compressedSize);
        compressedSize = Math.round((compressedBase64.length * 3) / 4);
      }
      
      files.value[fileIndex].base64 = compressedBase64;
      files.value[fileIndex].wasCompressed = true;
      files.value[fileIndex].isCompressing = false;
      files.value[fileIndex].compressedSize = compressedSize;
      
      console.log(`Imagen optimizada: ${file.name} - ${formatFileSize(file.size)} → ${formatFileSize(compressedSize)}`);
      
    } else {
      // Para archivos pequeños, convertir directamente pero verificar tamaño final
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        const base64Size = Math.round((base64.length * 3) / 4);
        
        files.value[fileIndex].base64 = base64;
        files.value[fileIndex].isCompressing = false;
        files.value[fileIndex].compressedSize = base64Size;
      };
      reader.readAsDataURL(file);
    }
    
  } catch (error) {
    console.error("Error al procesar imagen:", error);
    showToast("error", `Error al procesar ${file.name}`);
    // Remover el archivo con error
    const errorIndex = files.value.findIndex(f => f.name === file.name && !f.base64);
    if (errorIndex !== -1) {
      files.value.splice(errorIndex, 1);
    }
  }
};

// FUNCIÓN DE COMPRESIÓN EXTRA PARA CASOS EXTREMOS
const compressImageExtra = (file) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      try {
        // Configuración extra agresiva
        let maxWidth = 1024; // Muy pequeño
        let maxHeight = 768;
        let quality = 0.4; // Calidad muy baja
        
        // Si el archivo original era MUY grande, ser aún más agresivo
        if (file.size > 20 * 1024 * 1024) {
          maxWidth = 800;
          maxHeight = 600;
          quality = 0.3;
        }
        
        // Calcular dimensiones finales
        let { width, height } = img;
        const aspectRatio = width / height;
        
        if (width > height) {
          width = Math.min(width, maxWidth);
          height = width / aspectRatio;
        } else {
          height = Math.min(height, maxHeight);
          width = height * aspectRatio;
        }
        
        canvas.width = Math.round(width);
        canvas.height = Math.round(height);
        
        // Configurar para compresión máxima
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'medium'; // Reducir calidad de suavizado
        
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        
        const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
        resolve(compressedBase64);
        
      } catch (error) {
        reject(error);
      }
    };
    
    img.onerror = () => reject(new Error('Error al cargar imagen para compresión extra'));
    
    const reader = new FileReader();
    reader.onload = (e) => {
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
};

// FUNCIÓN DE COMPRESIÓN AVANZADA (MODIFICADA)
const compressImageAdvanced = (file) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      try {
        // Determinar nivel de compresión según el tamaño
        let config = {
          maxWidth: COMPRESSION_CONFIG.defaultMaxWidth,
          maxHeight: COMPRESSION_CONFIG.defaultMaxHeight,
          quality: COMPRESSION_CONFIG.defaultQuality
        };
        
        for (let level of COMPRESSION_CONFIG.compressionLevels) {
          if (file.size >= level.threshold) {
            config = level;
            break;
          }
        }
        
        // Calcular nuevas dimensiones
        let { width, height } = img;
        const aspectRatio = width / height;
        
        if (width > config.maxWidth || height > config.maxHeight) {
          if (aspectRatio > 1) {
            // Landscape
            width = Math.min(width, config.maxWidth);
            height = width / aspectRatio;
            
            if (height > config.maxHeight) {
              height = config.maxHeight;
              width = height * aspectRatio;
            }
          } else {
            // Portrait
            height = Math.min(height, config.maxHeight);
            width = height * aspectRatio;
            
            if (width > config.maxWidth) {
              width = config.maxWidth;
              height = width / aspectRatio;
            }
          }
        }
        
        canvas.width = Math.round(width);
        canvas.height = Math.round(height);
        
        // Configurar contexto
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        
        // Dibujar imagen redimensionada
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        
        // Convertir a base64
        const compressedBase64 = canvas.toDataURL('image/jpeg', config.quality);
        resolve(compressedBase64);
        
      } catch (error) {
        reject(error);
      }
    };
    
    img.onerror = () => reject(new Error('Error al cargar imagen'));
    
    const reader = new FileReader();
    reader.onload = (e) => {
      img.src = e.target.result;
    };
    reader.onerror = () => reject(new Error('Error al leer archivo'));
    reader.readAsDataURL(file);
  });
};

// FUNCIÓN PARA REMOVER ARCHIVOS (ARREGLADA)
const removeFile = (index) => {
  files.value.splice(index, 1);
  
  // Reordenar automáticamente
  files.value.forEach((file, newIndex) => {
    file.order = newIndex + 1;
  });
  
  showToast("success", "Archivo eliminado");
};

// FUNCIÓN PARA FORMATEAR TAMAÑO DE ARCHIVO
const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

const deleteImage = async (imageId) => {
  const url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/delete_images`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  const data = {
    image_id: imageId,
  };

  try {
    const response = await axios.post(url, data, options);

    if (response.status === 401) {
      console.log("Sesión expirada. Por favor, inicia sesión nuevamente.");
    }

    if (response.status === 200) {
      gallery.value = gallery.value.filter(img => img.id !== imageId);
      showToast("success", "Imagen eliminada correctamente");
      loader.value = false;
    }
  } catch (error) {
    console.error("Error al eliminar la imagen:", error);
    showToast("error", "Hubo un problema al eliminar la imagen");
  } finally {
    loader.value = false;
  }
};

// FUNCIÓN MEJORADA PARA GUARDAR CON LÍMITES ESTRICTOS
async function saveFiles() {
  if (files.value.length < 3) {
    showToast("warning", "Debes subir al menos 3 imágenes para poder guardar.");
    return;
  }

  // Verificar que todas las imágenes estén procesadas
  if (files.value.some(f => f.isCompressing || !f.base64)) {
    showToast("warning", "Espera a que terminen de procesarse todas las imágenes.");
    return;
  }

  // VERIFICAR TAMAÑOS ANTES DE ENVIAR
  const totalSize = files.value.reduce((sum, file) => sum + file.compressedSize, 0);
  const maxPayloadSize = 5 * 1024 * 1024; // 4.5MB para estar seguros
  
  console.log(`Tamaño total del payload: ${formatFileSize(totalSize)}`);
  
  if (totalSize > maxPayloadSize) {
    showToast("danger", `Las imágenes ocupan ${formatFileSize(totalSize)}. El límite es ${formatFileSize(maxPayloadSize)}. Elimina algunas imágenes.`);
    return;
  }

  // Verificar imágenes individuales
  const oversizedFiles = files.value.filter(f => f.compressedSize > 1 * 1024 * 1024); // 1MB por imagen
  if (oversizedFiles.length > 0) {
    showToast("danger", `${oversizedFiles.length} imágenes aún están muy grandes. Se recomprimirán.`);
    
    // Recomprimir archivos problemáticos
    for (let i = 0; i < files.value.length; i++) {
      if (files.value[i].compressedSize > 1 * 1024 * 1024) {
        files.value[i].isCompressing = true;
        
        // Buscar el archivo original en fileInput
        const originalFile = Array.from(fileInput.value?.files || [])
          .find(f => f.name === files.value[i].name);
        
        if (originalFile) {
          const recompressed = await compressImageExtra(originalFile, files.value[i].compressedSize);
          const newSize = Math.round((recompressed.length * 3) / 4);
          
          files.value[i].base64 = recompressed;
          files.value[i].compressedSize = newSize;
          files.value[i].isCompressing = false;
          files.value[i].wasCompressed = true;
          
          console.log(`Recompresión: ${files.value[i].name} → ${formatFileSize(newSize)}`);
        }
      }
    }
  }

  loader.value = true;
  
  try {
    let isUpdating = props.propertyId != 0;
    let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/upload_images`;

    let options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
      timeout: 120000, // 2 minutos
    };

    // ESTRATEGIA ULTRA-CONSERVADORA: Una imagen a la vez si el payload es grande
    const finalTotalSize = files.value.reduce((sum, file) => sum + file.compressedSize, 0);
    
    let batches = [];
    if (finalTotalSize > 3 * 1024 * 1024) { // Si > 3MB, ir de una en una
      batches = files.value.map(file => [file]);
      showToast("success", "Subiendo imágenes una por una debido al tamaño...");
    } else {
      // Enviar en lotes de máximo 2 imágenes
      for (let i = 0; i < files.value.length; i += 2) {
        batches.push(files.value.slice(i, i + 2));
      }
    }

    let allResponses = [];
    
    for (let [batchIndex, batch] of batches.entries()) {
      // Preparar datos para envío
      const batchData = batch.map(file => ({
        name: file.name,
        base64: file.base64,
        order: file.order
      }));
      
      const batchSize = batchData.reduce((sum, item) => {
        return sum + Math.round((item.base64.length * 3) / 4);
      }, 0);
      
      console.log(`Enviando lote ${batchIndex + 1}/${batches.length} (${formatFileSize(batchSize)})`);
      
      const response = await axios.post(url, batchData, options);
      
      if (response.status === 401) {
        console.log("Sesión expirada");
        return;
      }
      
      if (response.status === 200) {
        allResponses.push(response.data);
      }
      
      // Pequeña pausa entre lotes para no sobrecargar el servidor
      if (batchIndex < batches.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }

    showToast("success", "Imágenes guardadas correctamente");
    await getGallery();
    files.value = [];

    if (isUpdating) {
      await syncWithPropiedades(props.propertyId);
      await syncWithEasyBroker(props.propertyId);
    }

  } catch (error) {
    console.error("Error al guardar archivos:", error);
    
    if (error.code === 'ECONNABORTED') {
      showToast("danger", "Timeout: Intenta con menos imágenes a la vez.");
    } else if (error.response?.status === 413) {
      showToast("danger", "Payload demasiado grande. Intenta eliminar algunas imágenes.");
    } else if (error.response?.status === 422) {
      showToast("danger", "Error en el formato de datos. Verifica las imágenes.");
    } else {
      showToast("danger", "Error al guardar las imágenes. Verifica tu conexión.");
    }
  } finally {
    loader.value = false;
  }
}

// Resto de funciones sin cambios...
async function syncWithPropiedades(propertyId) {
  let syncUrl = `${process.env.VUE_APP_API_BASE_URL}/propertiesComUpdate/${propertyId}`;

  let syncOptions = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const syncResponse = await axios.put(syncUrl, {}, syncOptions);
    if (syncResponse.status === 200) {
      console.log("success", "Ubicación sincronizada con propiedades.com");
    } else {
      console.log("Error en sincronización: ", syncResponse.status);
    }
  } catch (error) {
    console.error("Error al sincronizar con propiedades.com:", error);
  }
}

async function syncWithEasyBroker(propertyId) {
  let url_sync = `${process.env.VUE_APP_API_BASE_URL}/editar-easybroker/${propertyId}`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url_sync, {}, options);

    if (
      response.status === 200 &&
      Array.isArray(response.data) &&
      response.data[0]?.status === "success"
    ) {
      console.log("[SYNC SUCCESS]", response.data);
      showToast("success", "Propiedad sincronizada con EasyBroker");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      console.warn("[SYNC WARNING] Error en respuesta:", response.data);
    }

  } catch (error) {
    console.error("[ERROR SYNCING WITH EASYBROKER]", error.response);
    showToast("error", "Error al sincronizar con EasyBroker");
  }
}

async function showToast(type, message) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

onMounted(async () => {
  console.log("entro a esta baina propiedad", props.propertyId);
  loader.value = true;
  await getGallery();
});

async function getGallery() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/gallery`;

  let options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.get(url, options);

    if (response.status == 401) {
      console.log("Hay que sacarlo de la sesion ");
    }

    if (response.status == 200) {
      showToast("success", response.data.message);
      gallery.value = response.data.resp;
    }
    loader.value = false;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

async function updateOrder(pos) {
  let field_order = gallery.value[pos].order;
  let field_id = gallery.value[pos].id;

  if (field_order != null || field_order != "" || field_order.length != 0) {
    let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/update_order_img`;

    let options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let param_post = {
      order: field_order,
      img_id: field_id,
    };

    try {
      const response = await axios.put(url, param_post, options);

      if (response.status == 401) {
        console.log("Hay que sacarlo de la sesion ");
      }

      if (response.status == 200) {
        console.log(response);
      }
      loader.value = false;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
}
</script>
    
<style scoped>
/* Estilos personalizados si los necesitas */
</style>